import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { GET_ALL_CAD_LINKS, GET_CONTACT_NOTES_BY_ID, GET_SELLER_BY_CONTACTID } from "../Graphql/ContactsQueries/contactsQuery";
import { PROPERTIES_MUTATION, PROPERTY_NOTES_MUTATION } from "../Graphql/Mutations/propertiesMutation";
import {
  Modal,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Paper
} from "@material-ui/core";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polygon,
} from "@react-google-maps/api";
import { booleanPointInPolygon, point, polygon } from "@turf/turf";
import React, { useCallback, useEffect, useRef, useState } from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Draggable from "react-draggable";
import {
  FaBuilding,
  FaChevronDown,
  FaChevronUp,
  FaEnvelope,
  FaGlobe,
  FaLocationArrow,
  FaMapMarkerAlt,
  FaPhone,
  FaRegBuilding,
  FaTimes
} from "react-icons/fa";
import { Link } from "react-router";
import { formatUserName, getNowDate, groupObjectByIndex } from "../../utils";
import { CREATE_OR_UPDATE_CONTACTS_SELLERS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_LIGHTBOX_DATA } from "../Graphql/Queries/getLightBoxData";
import {
  GET_ALL_PROPERTIES,
  GET_PROPERTY_BY_COORDS,
  GET_PROPERTY_NOTES,
  V7_PROPERTIES_LIST_DEV
} from "../Graphql/Queries/propertiesQuery";
import { fetchData as getData } from "../Service/graphQlService";
import StriveNotesDrawer from "./StriveNotesDrawer";
import "./StriveVision.scss";
import StriveVisionSearch from "./StriveVisionSearch";

let cloneDeep = require("lodash.clonedeep");
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'textarea, button'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function updateParams(param, field, limit) {
  const updated = { ...param };
  if (!updated[field]) return updated;

  // Convert comma string to array if needed
  if (typeof updated[field] === "string") {
    updated[field] = updated[field].split(",").map((item) => item.trim());
  }

  // Apply limit if provided
  if (limit) updated[field] = updated[field].slice(0, limit);

  return updated;
}

function updateOffsetImmutable(obj, newOffset) {
  return { ...obj, offset: newOffset };
}
function setQueryOrder(q) {
  const query = { ...q };
  if (query.source && query.source.toLowerCase() === 'strive' &&
    (query.status && query.status.toLowerCase() === 'closed' || query.hsc_status && query.hsc_status.toLowerCase() === 'closed')) {
    if (Array.isArray(query.order) && query.order.indexOf('close_of_escrow.desc') === -1) {
      query.order.push('close_of_escrow.desc');
      return query;
    }
    if (!query.order) {
      query.order = 'close_of_escrow.desc';
    }
  }
  return query;
}
// Main parseFilterOptions()
function parseFilterOptions(q) {
  // let query = setQueryOrder(q);
let query = { ...q };
  if (!query.order && q.source === "STRIVE" && q.status === "Active" && q.transaction_type === "Investment Sales") {
    query.order = "Listed_date.desc";
  }
  // Convert multi-select fields to arrays
  const multiSelectFields = ["status", "state"];
  multiSelectFields.forEach((field) => {
    if (query[field]) {
      // If it's already a string with commas, split it into an array
      query[field] = Array.isArray(query[field])
        ? query[field]
        : query[field].split(",").map((item) => item.trim());
    }
  });


  let propertiesQueryName = "V7_PROPERTIES_LIST_DEV";
  let responseListKey = "v7PropertiesList";

  if (query.hasOwnProperty("product_type_1") || query.hasOwnProperty("territory_1") || query.hasOwnProperty("territory_market_1")) {
    let territoryProductType = groupObjectByIndex(query).map((val, idx) => (`${val[`product_type_${idx + 1}`]}`)).join(',');
    const _types = new Set();
    const _categories = new Set();

    if (territoryProductType) {
      territoryProductType.split(",").forEach((product) => {
        let _type = product.split(" ");
        if (_type.length === 2) {
          _categories.add(_type[1]);
          _types.add(_type[0]);
        } else if (_type.length === 1) {
          _categories.add(_type[0]);
        }
      });
    }

    let category = "";
    let type = "";
    _categories.forEach((key) => (category += "," + key));
    _types.forEach((key) => (type += "," + key));

    category = category.replace(/^,|,$/g, "").toLowerCase();
    type = type.replace(/^,|,$/g, "");

    if (_types.size > 0) {
      query["type"] = type;
      query["category"] = category;
    } else if (_categories.size > 0) {
      query["category"] = category;
    } else if (query.product_type) {
      query["category"] = query.product_type.toLowerCase();
    }

    if (query["category"] && query["category"].includes("multi-family")) {
      query["category"] = query["category"].replace("multi-family", "apartments");
    }
  }

  const options = {
    param: { ...query },
  };

  options.param = updateParams(options.param, "status", 8);
  // options.param = updateParams(options.param, "type", 2);
  options.param = updateParams(options.param, "category", 5);
  options.param = updateParams(options.param, "zip", 120);
  options.param = updateParams(options.param, "market", 9);
  options.param = updateParams(options.param, "state");

  if (query.hasOwnProperty("product_type_1") || query.hasOwnProperty("territory_1") || query.hasOwnProperty("territory_market_1")) {
    options.param.territory_combinations = groupObjectByIndex(query);
  }

  let hscStatuses = [];
  for (const key in options.param) {
    if (key.startsWith("hsc_status_") && options.param[key] !== "NOMATCH") {
      hscStatuses.push(options.param[key]);
    }
  }
  if (hscStatuses.length) {
    options.param.hscStatuses = hscStatuses;
  }

  const updatedObject = updateOffsetImmutable(options.param, 0);

  return {
    updatedObject,
    originalParams: options.param,
    propertiesQueryName,
    responseListKey,
  };
}

// Merges DB property data with Lightbox data, preferring the most recent sale info.
function mergePropertyData(dbProperty, lightboxProperty) {
  if (!dbProperty) return lightboxProperty;

  // Helper: safely parse date
  function parseDate(dateStr) {
    return dateStr ? new Date(dateStr) : null;
  }

  const dbSaleDate = parseDate(dbProperty.close_of_escrow);
  const lbSaleDate = parseDate(lightboxProperty.saleDate);

  let useLightbox = false;
  if (lbSaleDate && dbSaleDate) {
    useLightbox = lbSaleDate > dbSaleDate;
  } else if (lbSaleDate && !dbSaleDate) {
    useLightbox = true;
  }

  const merged = {
    ...lightboxProperty,

    arcimedes_row_id: dbProperty.arcimedes_row_id || lightboxProperty.arcimedes_row_id,
    // Name
    name: dbProperty.name || lightboxProperty.name,

    // Building size
    livingArea:
      dbProperty.sqft != null
        ? Number(dbProperty.sqft)
        : lightboxProperty.livingArea * 3.28084 * 3.28084,

    // Year built
    yearBuilt: dbProperty.year_built || lightboxProperty.yearBuilt,

    // Lot size (keep from lightbox if not in DB)
    lotSize: dbProperty.lot_size ? dbProperty.lot_size : lightboxProperty.lotSize &&((lightboxProperty.lotSize * 3.28084 * 3.28084) /43560).toFixed(2),
    // APN
    apn: lightboxProperty.apn,
    // Coordinates
    lat: dbProperty.latitude ? Number(dbProperty.latitude) : lightboxProperty.lat,
    lng: dbProperty.longitude ? Number(dbProperty.longitude) : lightboxProperty.lng,

    // Status & transaction type
    status: dbProperty.status || lightboxProperty.status,
    transaction_type: dbProperty.transaction_type || lightboxProperty.transaction_type,

    lastSalePrice:
      dbProperty.price != null && dbProperty.price !== "0.00000000000000000000"
        ? Number(dbProperty.price)
        : lightboxProperty.lastSalePrice,

    capRate:
      dbProperty.cap_rate != null && dbProperty.cap_rate !== undefined
        ? dbProperty.cap_rate
        : lightboxProperty.capRate,
  };

  //  Seller, SaleDate, Lender, LoanValue — conditional logic
  if (useLightbox) {
    // --- Lightbox priority ---
    merged.saleDate = lightboxProperty.saleDate;

    merged.seller =
      lightboxProperty.seller ||
      lightboxProperty.owner ||
      (dbProperty.seller_first_name && dbProperty.seller_last_name
        ? dbProperty.seller_first_name + " " + dbProperty.seller_last_name
        : "");

    merged.lender = lightboxProperty.lender
      ? lightboxProperty.lender
      : dbProperty.lender_first_name
        ? (dbProperty.lender_first_name + " " + (dbProperty.lender_last_name || "")).trim()
        : "";

    merged.loanValue =
      lightboxProperty.loanValue != null
        ? lightboxProperty.loanValue
        : dbProperty.loan_amount != null
          ? Number(dbProperty.loan_amount)
          : null;
  } else {
    // --- DB priority ---
    merged.saleDate = dbProperty.close_of_escrow;

    merged.seller =
      dbProperty.seller_first_name && dbProperty.seller_last_name
        ? dbProperty.seller_first_name + " " + dbProperty.seller_last_name
        : lightboxProperty.seller || lightboxProperty.owner;

    merged.lender = dbProperty.lender_first_name
      ? (dbProperty.lender_first_name + " " + (dbProperty.lender_last_name || "")).trim()
      : lightboxProperty.lender;

    merged.loanValue =
      dbProperty.loan_amount != null
        ? Number(dbProperty.loan_amount)
        : lightboxProperty.loanValue;
  }

  return merged;
}

function StriveVision(props) {
  const [searchType, setSearchType] = useState("Address"); // New state to manage dropdown selection
  const [fipsNumber, setFipsNumber] = useState(""); // State for FIPS number input
  const [apnNumber, setApnNumber] = useState(""); // State for APN number input
  const [address, setAddress] = useState(""); // State for Address input
  const [fipsError, setFipsError] = useState("");
  const [apnError, setApnError] = useState("");
  const [searchError, setSearchError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [propertyLatLng, setPropertyLatLng] = useState({ lat: 0, lng: 0 });
  const [isStreetViewVisible, setIsStreetViewVisible] = useState(false);
  const [showPropertyPanel, setShowPropertyPanel] = useState(true);
  const mapRef = useRef(null);
  const streetViewRef = useRef(null);
  const defLat = 32.99488683886294;
  const defLng = -96.79856868841578;
  const [zoomCenter, setZoomCenter] = useState({
    lat: defLat,
    lng: defLng,
  });
  const [zoomLevel, setZoomLevel] = useState(18);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowProperties, setIsShowProperties] = useState(false);
  const [propertyBoundaries, setPropertyBoundaries] = useState([]);
  const [propertiesList, setPropertiesList] = useState([]);
  const [filteredPropertiesList, setFilteredPropertiesList] = useState([]);
  const [propertyNotes, setPropertyNotes] = useState([]);
  const [propertyOwner, setPropertyOwner] = useState();
  const [contactNotes, setContactNotes] = useState([])
  const [textInput, setTextInput] = useState("");
  const [showAddNotes, setIsShowAddNotes] = useState(false);
  const [isNotesReadOnly, setIsNotesReadOnly] = useState(false);
  const [notesId, setNotesId] = useState(null);
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]); // Autosuggest data
  const isSuggestionSelected = useRef(false);
  const isFilterSearch = useRef(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShowPropertiesExpanded, setIsShowPropertiesExpanded] =
    useState(false);
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false);
  const [deleteItem, setDeleteItem] = useState();
  const [selectedPropertySellerId, setSelectedPropertySellerId] =
    useState(null);
  const [selectedPropertyName, setSelectedPropertyName] =
    useState("");
  const [propertySourceType, setPropertySourceType] = useState([]);
  const [propertyStatusType, setPropertyStatusType] = useState([]);
  const [userLocation, setUserLocation] = useState(null);//for User Location Marker
  const [propertyForSearch, setPropertyForSearch] = useState(null); //to display Our DB Property details
  //  Property list and index
  const [propertyList, setPropertyList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = String(storedUserData.id) || "";
  const [showCompanyDetails, setShowCompanyDetails] = useState(false);
  const [cadLinksData, setCadLinksData] = useState([])
  const [isFetchingProperties, setIsFetchingProperties] = useState(false);

const fullName = formatUserName({
    firstName: storedUserData.firstName,
    lastName: storedUserData.lastName,
    username: storedUserData.username,
  });
  const isInvestorEdit = useRef(false);
  const isPropertySearch = useRef(false);

  // Navigate between properties
  const nextRecord = () => {
    if (propertyList.length === 0 || currentIndex === propertyList.length - 1) return;
    const nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);

    const nextProp = propertyList[nextIndex];
    const address = [nextProp.address, nextProp.city, nextProp.zip].filter(Boolean).join(", ");
    isFilterSearch.current = true;
    handleSearch(address, nextProp.address);
  };

  const prevRecord = () => {
    if (propertyList.length === 0 || currentIndex === 0) return;
    const prevIndex = currentIndex - 1;
    setCurrentIndex(prevIndex);

    const prevProp = propertyList[prevIndex];
    const address = [prevProp.address, prevProp.city, prevProp.zip].filter(Boolean).join(", ");
    isFilterSearch.current = true;
    handleSearch(address, prevProp.address);
  };

  //#region New
  // ---- Merge helpers for accumulating pins across map moves ----
  // ensures that the same property isn’t added multiple times when merging lists.
  const uniquePropKey = (item) => {
    // Prefer stable id; fallback to lat|lng|source|name combo
    const id = item && item.id ? item && item.propertyId : item && item.arcimedes_row_id;
    if (id != null) return `id:${id}`;
    return [
      "geo",
      item && item.latitude,
      item && item.longitude,
      (item && item.source || "").toLowerCase(),
      (item && item.name || "").toLowerCase(),
    ].join("|");
  };

  //Merges existing pins with newly fetched pins.
  const mergeProperties = (existing = [], incoming = []) => {
    const map = new Map();
    (existing || []).forEach((it) => map.set(uniquePropKey(it), it));
    (incoming || []).forEach((it) => {
      const key = uniquePropKey(it);
      if (!map.has(key)) map.set(key, it);
    });
    return Array.from(map.values());
  };

  //#endregion
  // ====== CLUSTER / MARKER HELPERS (per-source) ======
  const CLUSTER_ZOOM = 16; // pins when >= 16, clusters when < 16
  const SOURCE_KEYS = ["STRIVE", "HSC", "External", "db"];

  // Store per-source layers
  if (!window.striveLayers) window.striveLayers = {};

  // Source -> pin icon ---- Assigns different pin colors for each source.
  const iconForSource = (s) => {
    const key = (s || "").toLowerCase();
    if (key === "strive") return "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
    if (key === "hsc") return "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
    if (key === "external") return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
    if (key === "db") return "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
    return "";
  };

  // Source -> cluster circle color ---- Chooses cluster circle color based on source.
  const colorForSource = (source) => {
    const key = (source || "").toLowerCase();
    if (key === "strive") return "#4caf50";   // green
    if (key === "hsc") return "#3f51b5";      // blue
    if (key === "external") return "#fdd835"; // yellow
    if (key === "db") return "#EA390F";       // red
    return "#888888";
  };

  // Cluster renderer ---- Custom renderer to show count in colored circle
  const getClusterRenderer = (source) => ({
    render: ({ count, position }) => {
      const color = colorForSource(source);
      const svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <circle cx="20" cy="20" r="18" stroke="white" stroke-width="2" fill="${color}" />
        <text x="50%" y="50%" text-anchor="middle" fill="white" font-size="14" font-weight="bold" dy=".3em">${count}</text>
      </svg>
    `);
      return new google.maps.Marker({
        position,
        icon: { url: `data:image/svg+xml;base64,${svg}`, scaledSize: new google.maps.Size(40, 40) },
      });
    },
  });




  // Clears all markers & clusters for a given source from the map
  const clearSource = (src) => {
    const layer = window.striveLayers[src];
    if (layer && layer.clusterer) layer.clusterer.clearMarkers();
    if (layer && layer.markers && layer.markers.length) layer.markers.forEach(m => m.setMap(null));
    window.striveLayers[src] = { markers: [], clusterer: null };
  };

  // Builds Google Maps markers for a given source using filtered properties.
  const buildMarkersForSource = (src) => {
    const target = (src || "").toLowerCase();
    return (filteredPropertiesList || [])
      .filter(i => i.latitude && i.longitude && (i.source || "").toLowerCase() === target)
      .map(i => new window.google.maps.Marker({
        position: { lat: Number(i.latitude), lng: Number(i.longitude) },
        title: i.name,
        icon: iconForSource(i.source),
      }));
  };

  // Show pins individually
  const showPins = (src, markers) => {
    clearSource(src);
    markers.forEach(m => m.setMap(mapRef.current));
    window.striveLayers[src] = { markers, clusterer: null };
  };

  // Show clusters ---- Displays clustered markers with custom rendering.
  const showCluster = (src, markers) => {
    clearSource(src);
    const clusterer = new MarkerClusterer({
      map: mapRef.current,
      markers,
      renderer: getClusterRenderer(src),
    });
    window.striveLayers[src] = { markers, clusterer };
  };

  // Main render switcher ---- Decides per-source whether to show pins or clusters based on zoom level.
  const renderLayers = () => {
    if (!mapRef.current) return;
    const map = mapRef.current;
    const selected = new Set(propertySourceType || []);
    const zoom = map.getZoom();

    // Clear deselected
    SOURCE_KEYS.forEach(src => {
      if (!selected.has(src)) clearSource(src);
    });

    // Render selected
    SOURCE_KEYS.forEach(src => {
      if (!selected.has(src)) return;
      const markers = buildMarkersForSource(src);
      if (!markers.length) { clearSource(src); return; }
      if (zoom >= CLUSTER_ZOOM) showPins(src, markers);
      else showCluster(src, markers);
    });
  };

  //For Property color coding toggle
  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };
  //Show properties close and Open 
  const handleShowPropertiesClick = () => {
    setIsShowPropertiesExpanded(!isShowPropertiesExpanded);
  };

  const [
    CreateOrUpdatePropertyNotes,
    {
      loading: loadingUpdateNotes,
      error: errorUpdateNotes,
      data: dataUpdateNotes,
    },
  ] = useMutation(PROPERTY_NOTES_MUTATION);
  const [
    CreateOrUpdateContactsSellers,
    {
      loading: loadingUpdateSellersNotes,
      error: errorUpdateSellers,
      data: dataUpdateSellersNotes,
    },
  ] = useMutation(CREATE_OR_UPDATE_CONTACTS_SELLERS);
  const {
    loading: loadingNotes,
    error: errorNotes,
    data: dataNotes,
  } = useQuery(GET_PROPERTY_NOTES, {
    variables: {propertyId : propertyForSearch && propertyForSearch.arcimedes_row_id || null},
    fetchPolicy: "no-cache",
    context: {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    },
    skip:
      isNaN(propertyLatLng.lat) ||
      isNaN(propertyLatLng.lng) ||
      propertyLatLng.lat === 0 ||
      propertyLatLng.lng === 0 ||
      propertyForSearch === null,
  });

  //To Get All Strive Db Properties data
  const { data, loadingGetAllProperties, error, refetch } = useQuery(GET_ALL_PROPERTIES, {
    variables: {
      source: ["STRIVE", "External", "HSC", "db"],
      latitude: zoomCenter.lat.toString(),
      longitude: zoomCenter.lng.toString(),
    },
    context: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Example of adding authorization header
      },
    },
  });

  const { loading: loadingOwner, data: sellerData } = useQuery(
    GET_SELLER_BY_CONTACTID,
    {
      variables: { contactid: parseInt(selectedPropertySellerId) },
      context: {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
      skip: isNaN(selectedPropertySellerId) || selectedPropertySellerId == null,
    }
  );
  //get Property Details by coordinates
  const [getPropertyByCoords] = useLazyQuery(GET_PROPERTY_BY_COORDS, {
    fetchPolicy: "no-cache",
    context: {
      headers: { authorization: `Bearer ${localStorage.getItem("authToken")}` },
    },
  });
  const [getContactNotes, { loading: loadingContactNotes, data: ContactNotesData, refetch: refecthContactNotes }] = useLazyQuery(
    GET_CONTACT_NOTES_BY_ID,
    {
      context: {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
      fetchPolicy: "network-only", // optional, avoids cache
    }
  );
  const [createOrUpdateProperty] = useMutation(PROPERTIES_MUTATION, {
    context: {
      headers: { authorization: `Bearer ${localStorage.getItem("authToken")}` },
    },
  });

  const [getPropertiesList, { loading: loadingPropertiesList, data: PropertiesListData, refetch: refecthPropertiesList }] = useLazyQuery(
    V7_PROPERTIES_LIST_DEV,
    {
      context: {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
      fetchPolicy: "network-only", // optional, avoids cache
    }
  );

const [getAllCadSites] = useLazyQuery(GET_ALL_CAD_LINKS, {
  fetchPolicy: "no-cache",
  context: {
    headers: { authorization: `Bearer ${localStorage.getItem("authToken")}` },
  },
});

const fetchAllCadLinks = async () => {
  try {
    const { data } = await getAllCadSites({
      variables: {},
    });

    let cadSitesData = [];
    if (data && data.getAllCadSites && data.getAllCadSites.cadSites.length > 0) {
      cadSitesData = data.getAllCadSites.cadSites;
    }

    setCadLinksData(cadSitesData);
    console.log("Fetched cadlinks data:", cadSitesData);
  } catch (error) {
    console.error("Failed to fetch cadLinks:", error);
  }
};

  const fetchNotes = async () => {
    // Validate before making request
    if (!selectedPropertySellerId || isNaN(selectedPropertySellerId)) return;

    try {
      const { data } = await getContactNotes({
        variables: { contactId: String(selectedPropertySellerId) },
      });

      let notesData = [];
      if (data && data.getContactNotesByContactId && data.getContactNotesByContactId.length > 0) {
        notesData = data.getContactNotesByContactId;
      }

      setContactNotes(notesData);
      console.log("Fetched Contact Notes:", notesData);
    } catch (error) {
      console.error("Failed to fetch contact notes:", error);
    }
  };
  // Fetch properties list based on provided filter options
  const fetchPropertiesList = async (listOptions) => {
    try {
      const { data } = await getPropertiesList({
        variables: { listOptions, sortOptions: [] },
      });
      if (data && data.v7PropertiesList.length > 0) {
        setPropertyList(data.v7PropertiesList);
        setCurrentIndex(0);

        // Use existing handleSearch to show first record boundary
        const first = data.v7PropertiesList[0];
        const address = [first.address, first.city, first.zip]
          .filter(Boolean)
          .join(", ");
        //  setAddress(address);
        isFilterSearch.current = true;
        handleSearch(address, first.address);
        setSearchError("");
      }
      else {
        
        setSearchError("No property found with current filters");
        handleClearSearchFields()
        // handleClearInput("")
        // resetMap();
      }
      console.log("Propertiesdata:", data);
    } catch (error) {
      console.error("Failed to fetch contact notes:", error);
    }
  };

  // Fetch property list whenever query params change
  const location = props.location;
  
useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if ([...queryParams].length === 0) return;
    const q = Object.fromEntries(queryParams.entries());// 1️ Build the filter object from query params
    const { updatedObject, propertiesQueryName, responseListKey } = parseFilterOptions(q);// 2️ Prepare GraphQL options
    const listOptions = updatedObject;
    listOptions.lot_size_max = listOptions.lot_size_max ? Number(String(listOptions.lot_size_max).replace(/,/g, "")) : null;
    listOptions.lot_size_min = listOptions.lot_size_min ? Number(String(listOptions.lot_size_min).replace(/,/g, "")) : null;
    listOptions.sqft_max = listOptions.sqft_max ? Number(String(listOptions.sqft_max).replace(/,/g, "")) : null;
    listOptions.sqft_min = listOptions.sqft_min ? Number(String(listOptions.sqft_min).replace(/,/g, "")) : null;
    listOptions.year_built_max = listOptions.year_built_max ? Number(listOptions.year_built_max) : null;
    listOptions.year_built_min = listOptions.year_built_min ? Number(listOptions.year_built_min) : null;
    listOptions.isRover = true;

    fetchPropertiesList(listOptions);// 3️ Execute query

  }, [location.search]);
useEffect(()=>{
  fetchAllCadLinks();
},[])


  useEffect(() => {
    fetchNotes();
  }, [selectedPropertySellerId]);


  const parseJWT = (token) => {
    if (token) {
      const base64Url = token.split(".")[1]; // The payload is the second part of the JWT
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  };
  const getUser = () => {
    var token = localStorage.getItem("authToken");
    // const decodedToken = parseJWT(token);
    // if (decodedToken.firstName || decodedToken.lastName) {
    //   return token ? `${decodedToken.firstName} ${decodedToken.lastName}` : "";
    // } else {
    //   return token ? decodedToken.username : "";
    // }
    const decodedToken = parseJWT(token);

    if (decodedToken.firstName && decodedToken.lastName) {
      // Both first & last name → first letters capitalized, no space
      const first = decodedToken.firstName.charAt(0).toUpperCase() + decodedToken.firstName.slice(1);
      const last = decodedToken.lastName.charAt(0).toUpperCase() + decodedToken.lastName.slice(1);
      return token ? `${first} ${last}` : "";
    }
    else if (decodedToken.firstName) {
      // Only first name → first letter capitalized
      return token ? decodedToken.firstName.charAt(0).toUpperCase() + decodedToken.firstName.slice(1) : "";
    }
    else if (decodedToken.lastName) {
      // Only last name → first letter capitalized
      return token ? decodedToken.lastName.charAt(0).toUpperCase() + decodedToken.lastName.slice(1) : "";
    }
    else {
      // Only username → first 2 letters capitalized
      return token ? decodedToken.username.slice(0, 2).toUpperCase() + decodedToken.username.slice(2) : "";
    }

  };
  //To find selected property is exist in our Strive Properties or Not
  const GetPropertyOwner = async (selectedProperty) => {
    const queryParams = new URLSearchParams(location.search);
    try {
      if (!selectedProperty || !selectedProperty.boundaries || selectedProperty.boundaries.length === 0) {
        setSelectedPropertySellerId(null);
        setSelectedPropertyName("No property info");
        return;
      }

      // Convert to GeoJSON format and filter out invalid coordinates
      let geoJsonCoords = selectedProperty.boundaries
        .filter(function (coord) {
          return coord.lng != null && coord.lat != null && !isNaN(coord.lng) && !isNaN(coord.lat);
        })
        .map(function (coord) {
          return [coord.lng, coord.lat];
        });

      if (geoJsonCoords.length < 3) {
        setSelectedPropertySellerId(null);
        setSelectedPropertyName("No property info");
        return;
      }

      // Ensure polygon is closed
      const first = geoJsonCoords[0];
      const last = geoJsonCoords[geoJsonCoords.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        geoJsonCoords.push([first[0], first[1]]);
      }

      // Build GeoJSON polygon
      const boundary = polygon([geoJsonCoords]);

      // Find properties inside the selected boundary
      const propertyfound = propertiesList.filter(function (prop) {
        if (prop.latitude == null || prop.longitude == null || isNaN(prop.latitude) || isNaN(prop.longitude)) {
          return false;
        }
        const pt = point([prop.longitude, prop.latitude]);
        return booleanPointInPolygon(pt, boundary);
      });
      if (propertyfound && propertyfound.length > 0 && [...queryParams.keys()].length == 0) {
        const owner_id = propertyfound[0].buyer_id ? propertyfound[0].buyer_id : propertyfound[0].seller_id ? propertyfound[0].seller_id : null;
        const name = propertyfound[0].name;
        setSelectedPropertySellerId(owner_id || null);
        setSelectedPropertyName(name || "No property info");
        const dbProperty = propertyfound[0];
        const merged = mergePropertyData(dbProperty, selectedProperty);
        setPropertyForSearch(merged); // Set the property details for display
        return;
      }
      // else {
      //   // No properties found
      //   setSelectedPropertySellerId(null);
      //   setSelectedPropertyName("No property info");
      //   setPropertyForSearch(selectedProperty);
      // }
      else if (isPropertySearch.current || [...queryParams.keys()].length > 0) {//it will exicute when the searched address is not exist in getAllProperties response(i.e beyond 65 Km's)
        // const { data } = await getPropertyByCoords({
        //   variables: { lat: selectedProperty.lat, lng: selectedProperty.lng, address: selectedProperty.streetAddress },// lat and lang not required to pass we are searching with address only
        // });
        const queryParams = new URLSearchParams(location.search);
        const q = Object.fromEntries(queryParams.entries());
        const { updatedObject } = parseFilterOptions(q);
        const listOptions = updatedObject;
        // listOptions.lat = selectedProperty.lat,
        // listOptions.lng = selectedProperty.lng,
        // listOptions.address= selectedProperty.streetAddress
        listOptions.address = selectedProperty.filterAddress || selectedProperty.streetAddress;
        listOptions.lot_size_max = listOptions.lot_size_max ? Number(String(listOptions.lot_size_max).replace(/,/g, "")) : null;
        listOptions.lot_size_min = listOptions.lot_size_min ? Number(String(listOptions.lot_size_min).replace(/,/g, "")) : null;
        listOptions.sqft_max = listOptions.sqft_max ? Number(String(listOptions.sqft_max).replace(/,/g, "")) : null;
        listOptions.sqft_min = listOptions.sqft_min ? Number(String(listOptions.sqft_min).replace(/,/g, "")) : null;
        listOptions.year_built_max = listOptions.year_built_max ? Number(listOptions.year_built_max) : null;
        listOptions.year_built_min = listOptions.year_built_min ? Number(listOptions.year_built_min) : null;
        // Merge coordinates, address, and filters together
        const filterVariables = {
          lat: selectedProperty.lat,
          lng: selectedProperty.lng,
          // address: selectedProperty.streetAddress,
          filters: updatedObject, //remaining filters
        };

        const { data } = await getPropertyByCoords({//API call
          variables: filterVariables,
        });

        if (data && data.getPropertyByCoords) {
          const dbProperty = data.getPropertyByCoords;

          // If DB has null lat/lng but matching address, update DB with payload coords
          if (
            (!dbProperty.latitude || !dbProperty.longitude) &&
            dbProperty.address
            // &&
            // selectedProperty.address &&
            // dbProperty.address.trim().toLowerCase() === selectedProperty.streetAddress.trim().toLowerCase()
          ) {
            try {
              await createOrUpdateProperty({
                variables: {
                  input: {
                    arcimedes_row_id: dbProperty.arcimedes_row_id.toString(),
                    latitude: selectedProperty.lat,
                    longitude: selectedProperty.lng,
                    address: dbProperty.address,
                  },
                },
              });
              console.log("Updated DB property lat/lng from payload");
            } catch (err) {
              console.error("Failed to update property lat/lng:", err);
            }
          }

          const owner_id = dbProperty.buyer_id
            ? dbProperty.buyer_id
            : dbProperty.seller_id
              ? dbProperty.seller_id
              : null;
          const name = dbProperty.name;

          setSelectedPropertySellerId(owner_id || null);
          setSelectedPropertyName(name || "No property info");

          const merged = mergePropertyData(dbProperty, selectedProperty);
          setPropertyForSearch(merged); // Set merged property details for display
          isPropertySearch.current = false;
          return;
        }
      }
      // Step 3: fallback → show Lightbox data if DB also not found
      setSelectedPropertySellerId(null);
      setSelectedPropertyName("No property info");
      setPropertyForSearch(selectedProperty);
    } catch (error) {
      setSelectedPropertySellerId(null);
      setSelectedPropertyName("No property info");
    }
  };


const getCountyUrls = (countyName, cadLinksData) => {
  if (!countyName || !Array.isArray(cadLinksData)) return { county_Url: null, clerks_Url: null };

  // Normalize county name (e.g., "COLLIN" → "collin")
  const formattedCounty = countyName.trim().toLowerCase();

  // Find matching county entry
  const match = cadLinksData.find(
    (item) => item.county.toLowerCase() === formattedCounty
  );

  // Return both URLs if found
  return {
    county_Url: match ? match.site_url || null : null,
    clerks_Url: match ? match.clerks_url || null : null
  };
};

const county = propertyForSearch && propertyForSearch.county; // e.g., "COLLIN"

const { county_Url, clerks_Url } = getCountyUrls(county, cadLinksData);

  useEffect(() => {
    if (
      sellerData &&
      sellerData.getContactByContactid &&
      sellerData.getContactByContactid.contact
    ) {
      setPropertyOwner({ ...sellerData.getContactByContactid.contact });
      setSelectedPropertySellerId(null);
    }
  }, [sellerData]);



  useEffect(() => {
    if (selectedProperty) {
      setPropertyLatLng({
        lat: selectedProperty.lat,
        lng: selectedProperty.lng,
      });
      GetPropertyOwner(selectedProperty);
      setIsInfoWindowOpen(true);
    }
  }, [selectedProperty]);

  useEffect(() => {
    if (dataNotes) {
      let listvalues = cloneDeep(dataNotes.getPropertyNotes.data);
      setPropertyNotes(listvalues);
    }
  }, [dataNotes]);




  //To Set All Strive Db Properties Data
  // useEffect(() => {
  //   if (data) {
  //     let listvalues = cloneDeep(data.getAllProperties);
  //     setPropertiesList(listvalues);
  //     setIsShowProperties(true);
  //   }
  // }, [data]);

  //#region New 
  // Accumulate pins from GraphQL results (initial + every refetch)
  useEffect(() => {
    if (data && data.getAllProperties) {
      const incoming = data.getAllProperties;
      setPropertiesList((prev) => mergeProperties(prev, incoming));
      setIsShowProperties(true);
    }
  }, [data]);

  //#endregion

  useEffect(() => {
    let streetViewListener;
    if (mapRef.current) {
      streetViewRef.current = mapRef.current.getStreetView();
      streetViewListener = google.maps.event.addListener(
        streetViewRef.current,
        "visible_changed",
        () => {
          setIsStreetViewVisible(streetViewRef.current.getVisible());
        }
      );
    }
    return () => {
      if (streetViewListener) {
        google.maps.event.removeListener(streetViewListener);
      }
    };
  }, [mapRef.current]);

  const resetMap = () => {

    if (mapRef.current) {

      mapRef.current.setCenter(zoomCenter); // reset center

      mapRef.current.setZoom(zoomLevel);    // reset zoom

    }

  };

  // useEffect(()=>{
  // if(props.isClearRoverFilter){
  //   handleClearInput("")
  //     resetMap();
  // }
  // },[props.isClearRoverFilter])

  useEffect(() => {
    if (isShowProperties || props.isClearRoverFilter) {
      fetchNearByBoundaries(zoomCenter.lat, zoomCenter.lng)
        .then((propertyBoundaries) => {
          addNewPropertyBoundaries(propertyBoundaries);
        })
        .catch((e) => {
          console.error(e);
        });
      if (props.isClearRoverFilter) {
        handleClearInput("")
        setSearchError("");
        resetMap();

      }
    }
  }, [isShowProperties, props.isClearRoverFilter]);

  const fetchSuggestions = async (query) => {
    setSearchError("");
    if (isSuggestionSelected.current) {
      return; // Don't trigger the API if a suggestion was selected
    }

    //setIsLoading(true);
    try {
      // const response = await fetchData("/addresses/_autocomplete", {
      //   text: query,
      // });
      const result = await getData(GET_LIGHTBOX_DATA, { endPoint: "/addresses/_autocomplete", params: { text: query, } })
      const response = result && result.data && result.data.fetchData && result.data.fetchData.data
      if (response.addresses) {
        const filteredSuggestions = response.addresses.map(
          (item) => item.label
        );
        setSuggestions(filteredSuggestions);
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);
    } finally {
      // setIsLoading(false);
    }
  };

  // Handle input changes and trigger the API call after debounce
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (address.trim().length > 2) {
        fetchSuggestions(address);
      } else {
        setSuggestions([]);
      }
    }, 500);
    return () => clearTimeout(debounceTimeout);
  }, [address]);

  const handleSuggestionClick = (suggestion) => {
    setAddress(suggestion);
    isSuggestionSelected.current = true;
    setSuggestions([]);
    handleSearch(suggestion);
  };

  function wktToLatLngArray(wkt) {
    var latLngs = [];
    var wktClean = wkt.replace("POLYGON ((", "").replace("))", "");
    var coordinates = wktClean.split(", ");
    coordinates.forEach(function (coordinate) {
      var point = coordinate.split(" ");
      latLngs.push({ lat: parseFloat(point[1]), lng: parseFloat(point[0]) });
    });
    return latLngs;
  }

  const handleSearch = async (suggestionsearchtext, filterAddress = null) => {
    isPropertySearch.current = true
    const cameFromFilter = isFilterSearch.current;
    let isValid = true;
    // FIPS validation (only numbers)
    if (searchType === "FIPS") {
      if (fipsNumber == "" || apnNumber == "") {
        setApnError("Both apn & fips number should be given to search.");
        isValid = false;
      } else {
        setApnError("");
      }
    } else if (searchType === "Address") {
      if (address == "" && !cameFromFilter) {
        isValid = false;
        setAddressError("Please enter address.");
      } else {
        setAddressError("");
      }
    }
    if (isValid) {
      try {
        setIsLoading(true);
        setIsInfoWindowOpen(false);
        setSelectedProperty(null);
        setPropertyForSearch(null);
        setPropertyOwner(null);
        let result;
        if (searchType === "FIPS") {
          // response = await fetchData(
          //   `/parcels/us/fips/${fipsNumber}/apn/${apnNumber}`
          // );
          result = await getData(GET_LIGHTBOX_DATA, { endPoint: `/parcels/us/fips/${fipsNumber}/apn/${apnNumber}`, params: {} })
        }
        // else if (searchType === "Address") {
        //   if (suggestionsearchtext == "") {
        //     // response = await fetchData("/parcels/address", { text: address });
        //     result = await getData(GET_LIGHTBOX_DATA, { endPoint: "/parcels/address", params: { text: address } })
        //   } else {
        //     // response = await fetchData("/parcels/address", {
        //     //   text: suggestionsearchtext,
        //     // });
        //     result = await getData(GET_LIGHTBOX_DATA, { endPoint: "/parcels/address", params: { text: suggestionsearchtext } })
        //   }
        // }
        else if (searchType === "Address" || cameFromFilter) {
          const searchText = suggestionsearchtext || address;
          result = await getData(GET_LIGHTBOX_DATA, {
            endPoint: "/parcels/address",
            params: { text: searchText },
          });
        }

        const response = result && result.data && result.data.fetchData && result.data.fetchData.data
        if (response && response.parcels && response.parcels.length > 0) {
          setSearchError("");
          setIsLoading(false);
          var latLangs = wktToLatLngArray(
            response.parcels[0].location.geometry.wkt
          );

          let data = preparePropertyData(response.parcels[0], latLangs);
          data.filterAddress = filterAddress;
          setIsInfoWindowOpen(false);
          setSelectedProperty(data);
          handleFitBounds(data.boundaries);
        } else {
          setSearchError("No matching parcels found for your search criteria.");//No properties match the search criteria.
          setIsLoading(false);
        }
      } catch (e) {
        console.error(e);
        setSearchError("No property found.");
        setIsInfoWindowOpen(false);
        setSelectedProperty(null);
        setPropertyForSearch(null);
        setPropertyOwner(null);
        setIsLoading(false);
      } finally {
        isFilterSearch.current = false; // reset filter flag
      }
    }
  };

  const handleClearInput = (inputType) => {
    setFipsNumber("");
    setFipsError("");
    setApnError("");
    setSearchError("");
    setIsInfoWindowOpen(false);
    setSelectedProperty(null);
    setPropertyForSearch(null);
    setPropertyOwner(null);
    setApnNumber("");
    setAddress("");
    setAddressError("");
    setPropertyList([])
  };

  const handleClearSearchFields = () => {
    setIsInfoWindowOpen(false);
    setSelectedProperty(null);
    setPropertyForSearch(null);
    setPropertyOwner(null);
    setApnNumber("");
    setAddress("");
    setAddressError("");
    setPropertyList([])
  }

  const handleValueChange = (e) => {
    setIsInfoWindowOpen(false);
    setSelectedProperty(null);
    setPropertyForSearch(null);
    setPropertyOwner(null);
    setSearchType(e.target.value);
    if (e.target.value === "FIPS") {
      setSearchError("");
      setAddress("");
      setAddressError("");
    }
    if (e.target.value === "Address") {
      setFipsError("");
      setApnError("");
      setSearchError("");
      setFipsNumber("");
      setApnNumber("");
    }
  };

  const onLoad = useCallback((mapInstance) => {
    mapRef.current = mapInstance;
    //#region Rotation controls CSS adjustment
    // --- Adjust rotation and tilt controls after map is ready ---
  mapInstance.addListener("idle", () => {
    function adjustRotateTiltContainer() {
      const rotateClockwise = document.querySelector('[aria-label="Rotate map clockwise"]');
      if (rotateClockwise) {
        const parentDiv = rotateClockwise.closest("div[style*='background-color']");
        if (parentDiv) {
          parentDiv.style.marginLeft = "-22px";
          parentDiv.style.marginTop = "-42px";
        }
      }
    }

    // Apply initial adjustment
    adjustRotateTiltContainer();

    // Reapply if Google redraws controls
    const observer = new MutationObserver(() => adjustRotateTiltContainer());
    const gmStyle = document.querySelector(".gm-style");
    if (gmStyle) {
      observer.observe(gmStyle, { childList: true, subtree: true });
    }
  });
  //#endregion
  
  }, []);
  //it will execute when we click on Marker if there is no Boundary(i.e Zoom Out)
  const handleMapClick = (e) => {
    handleClearInput("");
    isSuggestionSelected.current = true;
    setPropertyNotes([]);
    setContactNotes([])
    const { latLng } = e;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setIsLoading(true);
    fetchPropertyBoundary(lat, lng)
      .then((property) => {
        setIsLoading(false);
        setIsInfoWindowOpen(false);
        setSelectedProperty(property);
        handleFitBounds(property.boundaries);
      })
      .catch((e) => {
        console.error(e);
        setIsLoading(false);
      });
  };
  // whenever we drag the mapit will call and also on change the zoom level it will excecute
  const handleMapChange = (e) => {
    if (mapRef && mapRef.current) {
      const zoom = mapRef.current.getZoom();
      const center = mapRef.current.getCenter(); // Get current map center (LatLng object)
      const lat = center.lat();
      const lng = center.lng();
      if (isLoading) return;

      if (
        zoom >= 8 &&
        ((zoomCenter.lat != lat && zoomCenter.lng != lng) ||
          zoomCenter.lat == defLat)
      ) {
        setIsFetchingProperties(true);
        fetchNearByBoundaries(lat, lng)
          .then((propertyBoundaries) => {
            addNewPropertyBoundaries(propertyBoundaries);
          })
        // Call getAllProperties API here
        refetch({
          source: ["STRIVE", "External", "HSC", "db"],
          latitude: lat.toString(),
          longitude: lng.toString(),
        })
          .then((res) => {
            if (res && res.data && res.data.getAllProperties) {
              // setPropertiesList(res.data.getAllProperties);
              // setIsShowProperties(true);

              const newProps = res.data.getAllProperties;
              setPropertiesList((prev) => mergeProperties(prev, newProps));
              setIsShowProperties(true);
              // Apply current filters immediately
              // filterDataAsync(propertySourceType, propertyStatusType).then((result) => {
              //   setFilteredPropertiesList([...result]);
              // });
            }
          })
          .catch((e) => {
            console.error(e);
          }).finally(() => {
          setIsFetchingProperties(false);
        });
      } else {
        if (zoom >= 16) {
          setZoomCenter({ lat, lng });
          setZoomLevel(zoom);
        }
      }
    }
  };
  //to get the selected Property Boundary
  const fetchPropertyBoundary = (lat, lng) => {
    return new Promise((resolve, reject) => {
      // fetchData("/parcels/us/geometry", {
      //   wkt: `POINT(${lng} ${lat})`,
      //   // bufferDistance: 10,
      //   // bufferUnit: "m",
      //   limit: 1,
      // })
      getData(GET_LIGHTBOX_DATA, {
        endPoint: "/parcels/us/geometry", params: {
          wkt: `POINT(${lng} ${lat})`,
          // bufferDistance: 10,
          // bufferUnit: "m",
          limit: 1,
        }
      })
        .then((result) => {
          const response = result && result.data && result.data.fetchData && result.data.fetchData.data
          if (response && response.parcels && response.parcels.length > 0) {
            let latLangsarray = [];
            for (let i = 0; i < response.parcels.length; i++) {
              let latLangs = wktToLatLngArray(
                response.parcels[i].location.geometry.wkt
              );
              if (response.parcels[i]) {
                latLangsarray.push(
                  preparePropertyData(response.parcels[i], latLangs)
                );
              }
            }
            resolve(latLangsarray[0]);
          } else {
            reject();
          }
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  };

  const preparePropertyData = (propertyItem, latLangs) => {
    try {
      if (propertyItem) {
        let data = {
          id: propertyItem.id,
          owner:
            propertyItem.owner.names && propertyItem.owner.names.length > 0
              ? propertyItem.owner.names[0].fullName
              : "",
          ownerStreetAddress: propertyItem.owner.streetAddress,
          ownerLocality: propertyItem.owner.locality,
          ownerRegionCode: propertyItem.owner.regionCode,
          ownerPostalCode: propertyItem.owner.postalCode,
          address:
            propertyItem.location.streetAddress +
            " " +
            propertyItem.location.locality +
            ", " +
            propertyItem.location.regionCode +
            " " +
            propertyItem.location.postalCode,
          streetAddress: propertyItem.location.streetAddress,
          locality: propertyItem.location.locality,
          regionCode: propertyItem.location.regionCode,
          postalCode: propertyItem.location.postalCode,
          apn: propertyItem.parcelApn,
          fips: propertyItem.fips,
          lotSize: propertyItem.assessment.lot.size,
          marketValue: propertyItem.assessment.marketValue.total,
          assessedValue: propertyItem.assessment.assessedValue.total,
          assessedalueYear: propertyItem.assessment.assessedValue.year,
          zoning: propertyItem.assessment.zoning.assessment,
          landUseCategory: propertyItem.landUse.normalized.categoryDescription,
          landUseDescription: propertyItem.landUse.normalized.description,
          lastSalePrice: propertyItem.transaction.lastMarketSale.value,
          seller: propertyItem.transaction.lastMarketSale.seller,
          buyer: propertyItem.transaction.lastMarketSale.buyer,
          titleCompany: propertyItem.transaction.lastMarketSale.titleCompany,
          yearBuilt: propertyItem.primaryStructure.yearBuilt,
          livingArea: propertyItem.primaryStructure.livingArea,
          numberOfUnits: propertyItem.primaryStructure.units,
          lender: propertyItem.transaction.lastMarketSale.lender,
          loanValue:
            (propertyItem.transaction
              && propertyItem.transaction.lastMarketSale
              && propertyItem.transaction.lastMarketSale.loan
              ? (propertyItem.transaction.lastMarketSale.loan.first || 0)
              : 0),
          lat: propertyItem.location.representativePoint.latitude,
          lng: propertyItem.location.representativePoint.longitude,
          boundaries: latLangs,
          saleDate:propertyItem.transaction
              && propertyItem.transaction.lastMarketSale
              && propertyItem.transaction.lastMarketSale.transferDate ? propertyItem.transaction.lastMarketSale.transferDate : "",
            county :   propertyItem.county ? propertyItem.county : ""  
        };
        return data;
      }
    } catch (ex) {
      console.error("ex", ex);
    }
  };

  const fetchNearByBoundaries = async (lat, lng) => {
    return new Promise((resolve, reject) => {
      // fetchData("/parcels/us/geometry", {
      //   wkt: `POINT(${lng} ${lat})`,
      //   bufferDistance: 250,
      //   bufferUnit: "m",
      //   limit: 70,
      // })
      getData(GET_LIGHTBOX_DATA, {
        endPoint: "/parcels/us/geometry", params: {
          wkt: `POINT(${lng} ${lat})`,
          bufferDistance: 250,
          bufferUnit: "m",
          limit: 70,
        }
      })
        .then((result) => {
          const response = result && result.data && result.data.fetchData && result.data.fetchData.data

          if (response && response.parcels && response.parcels.length > 0) {
            let latLangsarray = [];
            for (let i = 0; i < response.parcels.length; i++) {
              let latLangs = wktToLatLngArray(
                response.parcels[i].location.geometry.wkt
              );
              if (response.parcels[i]) {
                latLangsarray.push(
                  preparePropertyData(response.parcels[i], latLangs)
                );
              }
            }
            resolve(latLangsarray);
          } else {
            reject();
          }
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  };
  // to add new boundaries to the existing boundaries when we drag
  const addNewPropertyBoundaries = (newPropertyBoundaries) => {
    const updatedPropertyBoundaries = [...propertyBoundaries];

    newPropertyBoundaries.forEach((newPropertyitem) => {
      if (newPropertyitem) {
        // Check if the coordinate already exists
        const exists = updatedPropertyBoundaries.some(
          (existingitem) => existingitem.id === newPropertyitem.id
        );

        // If it doesn't exist, add the new coordinate
        if (!exists) {
          updatedPropertyBoundaries.push(newPropertyitem);
        }
      }
    });
    setPropertyBoundaries([...updatedPropertyBoundaries]);
  };

  useEffect(() => {
    if (!selectedProperty) {
      setFipsNumber("");
      setApnNumber("");
      setAddress("");
    } else {
      setFipsNumber(selectedProperty.fips);
      setApnNumber(selectedProperty.apn);
      setAddress(selectedProperty.address);
    }
  }, [selectedProperty]);
  //when ever there is a polygons or boundries on Map if we click on them it will execute
  const handlePolyClick = (item) => {
    handleClearInput("");
    if (item) {
      isSuggestionSelected.current = true;
      setPropertyNotes([]);
      setContactNotes([])
      setIsInfoWindowOpen(false);
      setSelectedProperty(item);
      handleFitBounds(item.boundaries);
    }
  };

  const handleFitBounds = (latLangs) => {
    if (mapRef && mapRef.current && latLangs) {
      let bounds = new google.maps.LatLngBounds();
      latLangs.forEach((coord) => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });
      // Fit the map to the polygon's bounds
      mapRef.current.fitBounds(bounds);
    }
  };

  const mapContainerStyle = {
    height: "calc(100vh - 64px)",
    width: "100%",
  };

  const options = {
    fullscreenControl: false,
    minZoom: 10,
  };

  const closeModal = () => {
    setIsShowAddNotes(false);
    setTextInput("");
    setNotesId(null);
    if (isInvestorEdit.current) {
      isInvestorEdit.current = false;
    }
  };

  const handlePropertyNotesSubmit = () => {
    let user = getUser();
    console.log("user - ", user);
    CreateOrUpdatePropertyNotes({
      variables: {
        input: [{
          arcimedes_row_id: notesId ? notesId : "",
          latitude: selectedProperty.lat,
          address: selectedProperty.address,
          created_by: user,
          longitude: selectedProperty.lng,
          modified_by: user,
          notes: textInput,
          deleted: selectedProperty.deleted,
          property_id: propertyForSearch.arcimedes_row_id || null,
        }],
      },
      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
    })
      .then(() => {
        setNotesId("");
        setTextInput(""); // Clear the input after submission
        setIsShowAddNotes(false);
      })
      .catch((er) => {
        console.error("error - ", er);
        setNotesId("");
        setTextInput(""); // Clear the input after submission
        setIsShowAddNotes(false);
      });
  };

  function cleanContactNotes(notes, newTextInput, arcimedesRowId, contactId, userId, fullName) {
    const latestDate = getNowDate();

    // Case 1: Updating existing record
    if (arcimedesRowId) {
      const updatedNote = notes.find(note => note.arcimedes_row_id === arcimedesRowId);

      if (!updatedNote) return []; // No match found, return empty array

      const {
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
        date,
        ...cleanedNote
      } = updatedNote;

      return [
        {
          ...cleanedNote,
          text: newTextInput,
          // date: latestDate,
          user_name: fullName,
        }
      ];
    }

    // Case 2: Creating new record (no arcimedes_row_id yet)
    return [
      {
        text: newTextInput,
        // date: latestDate,
        user_name: fullName,
        user_id: userId,
        contact_id: contactId,
      }
    ];
  }


  const handlePropertyOwnerNotesSubmit = () => {
    const cleanedNote = cleanContactNotes(contactNotes, textInput, notesId, propertyOwner.contact_id, user_id, fullName);

    if (propertyOwner.contact_id && propertyOwner.contact_id !== "") {
      CreateOrUpdateContactsSellers({
        variables: {
          input: {
            contact_id: propertyOwner.contact_id,
            notes: cleanedNote,
            contact_type: propertyOwner.contact_type,
          },
        },
        fetchPolicy: "no-cache",
        context: {
          headers: {
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        },
      })
        .then((res) => {
          let serverNotes = [];

          if (
            res &&
            res.data &&
            res.data.createOrUpdateContact &&
            res.data.createOrUpdateContact.contact &&
            res.data.createOrUpdateContact.contact.notes
          ) {
            serverNotes = res.data.createOrUpdateContact.contact.notes;
          }

          if (serverNotes.length > 0) {
            //  Replace state with server’s latest notes only
            setContactNotes(serverNotes);
          } else {
            setContactNotes([])
            // fallback to force refetch
            // refecthContactNotes({ fetchPolicy: "network-only" }); no need to call api handleing with state
          }

          setNotesId("");
          setTextInput("");
          setIsShowAddNotes(false);
          if (isInvestorEdit.current) {
            isInvestorEdit.current = false;
          }
        })
        .catch((er) => {
          console.error("error - ", er);
          setNotesId("");
          setTextInput("");
          setIsShowAddNotes(false);
        });
    }
  };


  const handleSubmit = () => {
    if (isInvestorEdit.current) {
      handlePropertyOwnerNotesSubmit();
    } else {
      handlePropertyNotesSubmit();
    }
  };

  const handleDeleteNote = (item) => {
    setDeleteItem(item);
    setIsDeleteConfirm(true);
  };
  const submitDelete = () => {
    setIsDeleteConfirm(false);
    if (!deleteItem) return;

    if (notesId) {

      const { __typename, arcimedes_modified_by, arcimedes_modified, arcimedes_created_by, arcimedes_created, agent_firm, agent, ...cleanPropertyOwner } = propertyOwner;

      // Prepare notes array with deleted flag
      const deleteNotes = textInput.map(({
        __typename,
        arcimedes_created,
        arcimedes_created_by,
        arcimedes_modified,
        arcimedes_modified_by,
        ...rest
      }) => ({
        ...rest,
        deleted: 1, // force deleted flag
      }));


      // Create the final input object with updated arcimedes_row_id and notes
      const propertyOwnerDeleteInput = {
        ...cleanPropertyOwner,                               // all fields except __typename
        arcimedes_row_id: Number(deleteItem.arcimedes_row_id), // update arcimedes_row_id if needed
        notes: deleteNotes,                                  // attach notes with deleted: 1
      };
      CreateOrUpdateContactsSellers({
        variables: {
          input: propertyOwnerDeleteInput,
        },
        fetchPolicy: "no-cache",
        context: {
          headers: {
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        },
      })
        .then((res) => {
          let serverNotes = [];

          if (
            res &&
            res.data &&
            res.data.createOrUpdateContact &&
            res.data.createOrUpdateContact.contact &&
            res.data.createOrUpdateContact.contact.notes
          ) {
            serverNotes = res.data.createOrUpdateContact.contact.notes;
          }

          if (serverNotes.length > 0) {
            //  replace state with latest server notes
            setContactNotes(serverNotes);
          } else {
            setContactNotes([])
            // fallback → force refetch
            // refecthContactNotes({ fetchPolicy: "network-only" });

          }

          setNotesId("");
          setTextInput("");
          setIsShowAddNotes(false);
          setDeleteItem(null);
        })
        .catch((er) => {
          console.error("error - ", er);
          setNotesId("");
          setTextInput("");
          setIsShowAddNotes(false);
          setDeleteItem(null);
        });

    } else {
      let user = getUser();
      CreateOrUpdatePropertyNotes({
        variables: {
          input: {
            arcimedes_row_id: deleteItem.ARCIMEDES_ROW_ID,
            latitude: selectedProperty.lat,
            address: deleteItem.ADDRESS,
            created_by: user,
            longitude: selectedProperty.lng,
            modified_by: user,
            notes: deleteItem.NOTES,
            deleted: 1,
          },
        },
        fetchPolicy: "no-cache",
        context: {
          headers: {
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        },
      })
        .then(() => {
          setTextInput(""); // Clear the input after submission
          setIsShowAddNotes(false);
          setDeleteItem();
        })
        .catch((er) => {
          setDeleteItem();
          console.error("error - ", er);
        });
    }
    // if (deleteItem) {
    //   let user = getUser();
    //   CreateOrUpdatePropertyNotes({
    //     variables: {
    //       input: {
    //         arcimedes_row_id: deleteItem.ARCIMEDES_ROW_ID,
    //         latitude: selectedProperty.lat,
    //         address: deleteItem.ADDRESS,
    //         created_by: user,
    //         longitude: selectedProperty.lng,
    //         modified_by: user,
    //         notes: deleteItem.NOTES,
    //         deleted: 1,
    //       },
    //     },
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${localStorage.getItem("authToken")}`,
    //       },
    //     },
    //   })
    //     .then(() => {
    //       setTextInput(""); // Clear the input after submission
    //       setIsShowAddNotes(false);
    //       setDeleteItem();
    //     })
    //     .catch((er) => {
    //       setDeleteItem();
    //       console.error("error - ", er);
    //     });
    // }
  };

  useEffect(() => {
    if (
      dataUpdateSellersNotes &&
      dataUpdateSellersNotes.createOrUpdateContact
    ) {
      const { contact } = dataUpdateSellersNotes.createOrUpdateContact;
      setPropertyOwner({ ...contact });
    }
  }, [dataUpdateSellersNotes]);

  useEffect(() => {
    if (dataUpdateNotes) {
      let newValue = dataUpdateNotes.createOrUpdatePropertyNotes.PropertyNotes;
      if (propertyNotes && propertyNotes.length > 0) {
        const noteIndex = propertyNotes.findIndex(
          (note) => note.ARCIMEDES_ROW_ID === newValue[0].ARCIMEDES_ROW_ID
        );

        if (newValue[0].DELETED === 1) {
          if (noteIndex !== -1) {
            const updatedPropertyNotes = propertyNotes.filter(
              (note) => note.ARCIMEDES_ROW_ID !== newValue[0].ARCIMEDES_ROW_ID
            );
            setPropertyNotes(updatedPropertyNotes);
          }
        } else {
          if (noteIndex !== -1) {
            // propertyNotes[noteIndex] = newValue;
            // setPropertyNotes([...propertyNotes]);

            const updatedPropertyNotes = [...propertyNotes];
            updatedPropertyNotes[noteIndex] = newValue[0];
            setPropertyNotes(updatedPropertyNotes);         
          } else {
       const updatedNotes = [...newValue, ...propertyNotes];
       setPropertyNotes(updatedNotes);
          }
        }
      } else {
        setPropertyNotes(newValue);
      }
    }
  }, [dataUpdateNotes]);

  useEffect(() => {
    if (!mapRef.current || !isShowProperties) return;

    if (!propertySourceType || propertySourceType.length === 0) {
      SOURCE_KEYS.forEach(clearSource);
      return;
    }

    renderLayers();

    return () => {
      SOURCE_KEYS.forEach(clearSource);
    };
  }, [filteredPropertiesList, isShowProperties, propertySourceType]);


  useEffect(() => {
    if (!mapRef.current) return;

    const map = mapRef.current;
    const listener = google.maps.event.addListener(map, "zoom_changed", () => {
      renderLayers();
    });

    return () => google.maps.event.removeListener(listener);
  }, [filteredPropertiesList, propertySourceType, isShowProperties]);
  //#region New
  // Keep filtered pins in sync whenever props list or filters change
  useEffect(() => {
    const sources = propertySourceType || [];
    const statuses = propertyStatusType || [];

    const next = (propertiesList || []).filter((item) => {
      if (!sources.includes(item && item.source)) return false;
      if (statuses.length > 0) return statuses.includes(item && item.status);
      return true;
    });

    setFilteredPropertiesList(next);
  }, [propertiesList, propertySourceType, propertyStatusType]);

  //#endregion

  const getFillColor = (value) => {
    if (value == "RESIDENTIAL") {
      return "green";
    } else if (value == "COMMERCIAL (RETAIL)") {
      return "yellow";
    } else if (value == "INDUSTRIAL (GENERAL)") {
      return "blue";
    } else if (value == "OTHER") {
      return "#FF0000";
    }
  };

  const legendItems = [
    { color: "green", label: "RESIDENTIAL" },
    { color: "yellow", label: "COMMERCIAL (RETAIL)" },
    { color: "blue", label: "INDUSTRIAL (GENERAL)" },
    { color: "#FF0000", label: "OTHER" },
  ];

  // const showLocation = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       const { latitude, longitude } = position.coords;
  //       const newCenter = { lat: latitude, lng: longitude };
  //       setZoomCenter(newCenter);
  //     });
  //   }
  // };
  const showLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;

          if (mapRef.current) {
            mapRef.current.panTo({ lat: userLat, lng: userLng });
            mapRef.current.setZoom(16); // closer zoom
          }

          setUserLocation({ lat: userLat, lng: userLng });
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Unable to retrieve your location. Please check location permissions.");
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  function useDebounce(callback, delay) {
    const timeoutRef = useRef(null);

    const debouncedFunction = useCallback(
      (...args) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          callback(...args);
        }, delay);
      },
      [callback, delay]
    );

    return debouncedFunction;
  }
  //It will filter the All Strive DB Properties based on Source and Status
  const filterDataAsync = async (selectedSource, selectedStatus) => {
    if (selectedStatus.length > 0) {
      return propertiesList.filter(
        (item) =>
          selectedSource.includes(item.source) &&
          selectedStatus.includes(item.status)
      );
    } else {
      return propertiesList.filter((item) =>
        selectedSource.includes(item.source)
      );
    }
  };

  const debouncedFilter = useDebounce(
    async (selectedSource, selectedStatus) => {
      const result = await filterDataAsync(selectedSource, selectedStatus);
      setFilteredPropertiesList([...result]);
      setIsShowProperties(true);
    },
    500
  );
  // It will execute For Status change
  const handleStatusChange = (event) => {
    const { name, checked } = event.target;
    const updated = checked
      ? [...propertyStatusType, name]
      : propertyStatusType.filter((n) => n !== name);
    setIsShowProperties(false);
    setPropertyStatusType(updated);
    debouncedFilter(propertySourceType, updated);
  };
  //It will execute For Source change
  const handleChange = (event) => {
    const { name, checked } = event.target;
    const updated = checked
      ? [...propertySourceType, name]
      : propertySourceType.filter((n) => n !== name);
    setIsShowProperties(false);
    setPropertySourceType(updated);
    debouncedFilter(updated, propertyStatusType);
  };

  const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
  return (
    <div
      className="StriveVision"
      style={{
        height: "100%",
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "visible",
      }}
    >
      <Backdrop
        style={{ zIndex: 1001 }}
        open={
          isLoading ||
          loadingUpdateNotes ||
          loadingNotes ||
          loadingOwner ||
          loadingUpdateSellersNotes ||
          loadingContactNotes ||
          loadingPropertiesList
        }
      >
        <CircularProgress />
      </Backdrop>
      <Dialog open={isDeleteConfirm} onClose={() => setIsDeleteConfirm(false)}>
        <DialogContent>Do you Really want to delete?</DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteConfirm(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={submitDelete} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <LoadScript
        googleMapsApiKey="AIzaSyDGktwxbb0xZmCadduTN59ErIU_TBu4soE"
        libraries={["places"]}
      >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={zoomCenter}
          zoom={zoomLevel}
          options={options}
          onClick={handleMapClick}
          onLoad={onLoad}
          onZoomChanged={handleMapChange}
          onDragEnd={handleMapChange}
          ref={mapRef}
        >
          <div className="legend-container" style={{ zIndex: 2000, marginRight: '200px' }}>
            <div className="legend-container-header">
              <ArrowBackIosIcon
                style={{ cursor: currentIndex === 0 ? "not-allowed" : "pointer", color: (currentIndex === 0 || propertyList.length === 0) ? 'gray' : 'rgb(144, 197, 75)' }}
                disabled={currentIndex === 0 || isLoading}
                onClick={prevRecord}
              />
              <ArrowForwardIosIcon
                style={{ cursor: (currentIndex === propertyList.length - 1 || propertyList.length === 0) ? "not-allowed" : "pointer", color: (currentIndex === propertyList.length - 1 || propertyList.length === 0) ? 'grey' : 'rgb(144, 197, 75)' }}
                disabled={currentIndex === propertyList.length - 1 || isLoading}
                onClick={nextRecord}
              />
            </div>
          </div>
          <div className="legend-container">
            <div className="legend-container-header">
              <span>
                <b>Property Color Coding</b>
              </span>
              {isExpanded ? (
                <FaChevronUp
                  style={{ cursor: "pointer" }}
                  onClick={handleClick}
                />
              ) : (
                <FaChevronDown
                  style={{ cursor: "pointer" }}
                  onClick={handleClick}
                />
              )}
            </div>
            {isExpanded && (
              <ul className="legend-list">
                {legendItems.map((item, index) => (
                  <li key={index} className="legend-item">
                    <div
                      className="color-box"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span className="color-label">{item.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {
            <div
              className="show-properties-container"
              style={{ width: isShowPropertiesExpanded && "294px" }}
            >
              <div className="show-properties-container-header">
                <span className="d-flex-center">
                  <FaRegBuilding />
                  <b>Show Properties</b>
                </span>
                {isFetchingProperties && (
                    <span
                      className="loading-text"
                      style={{
                        marginLeft: "8px",
                        fontSize: "13px",
                        color: "blue",
                        fontWeight: "normal",
                      }}
                    >
                      Loading Properties...
                    </span>
                  )}
                {!isShowProperties ? (
                  <CircularProgress size={14} />
                ) : isShowPropertiesExpanded ? (
                  <FaChevronUp
                    style={{ cursor: "pointer" }}
                    onClick={handleShowPropertiesClick}
                  />
                ) : (
                  <FaChevronDown
                    style={{ cursor: "pointer" }}
                    onClick={handleShowPropertiesClick}
                  />
                )}
              </div>
              {isShowPropertiesExpanded && (
                <FormControl
                  className="d-flex"
                  component="fieldset"
                  variant="standard"
                >
                  <div
                    className="d-flex-div"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <span>
                      <b>Category</b>
                    </span>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertySourceType.includes("STRIVE")}
                            onChange={handleChange}
                            name="STRIVE"
                            style={{
                              color: "#4caf50",
                              "&.Mui-checked": {
                                color: "#4caf50",
                              },
                            }}
                          />
                        }
                        label="STRIVE"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertySourceType.includes("HSC")}
                            onChange={handleChange}
                            name="HSC"
                            style={{
                              color: "#3f51b5",
                              "&.Mui-checked": {
                                color: "#3f51b5",
                              },
                            }}
                          />
                        }
                        label="AthCap"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertySourceType.includes("External")}
                            onChange={handleChange}
                            name="External"
                            style={{
                              color: "#fdd835",
                              "&.Mui-checked": {
                                color: "#fdd835",
                              },
                            }}
                          />
                        }
                        label="External"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertySourceType.includes("db")}
                            onChange={handleChange}
                            name="db"
                            style={{
                              color: "#EA390F",
                              "&.Mui-checked": {
                                color: "#EA390F",
                              },
                            }}
                          />
                        }
                        label="DB"
                      />
                    </FormGroup>
                  </div>
                  <div className="d-flex-div">
                    <span>
                      <b>Filter By Status</b>
                    </span>
                    <FormGroup style={{ display: "flex" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertyStatusType.includes("Active")}
                            onChange={handleStatusChange}
                            name="Active"
                          />
                        }
                        label="Active"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertyStatusType.includes(
                              "In Negotiation"
                            )}
                            onChange={handleStatusChange}
                            name="In Negotiation"
                          />
                        }
                        label="In Neg."
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertyStatusType.includes(
                              "Under Contract"
                            )}
                            onChange={handleStatusChange}
                            name="Under Contract"
                          />
                        }
                        label="Under Con."
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={propertyStatusType.includes("Closed")}
                            onChange={handleStatusChange}
                            name="Closed"
                          />
                        }
                        label="Closed"
                      />
                    </FormGroup>
                  </div>
                </FormControl>
              )}
            </div>
          }
          {propertyBoundaries &&
            propertyBoundaries.length > 0 &&
            propertyBoundaries.map((item, index) => {
              return (
                // to get Boundries on GoogleMap we need to add a Polgyon as child component
                <Polygon
                  key={item.id}
                  paths={item.boundaries}
                  options={{
                    fillColor: "#FF0000",
                    fillOpacity: 0,
                    strokeColor: "black",
                    strokeOpacity: 1,
                    strokeWeight: 2,
                  }}
                  onClick={() => handlePolyClick(item)}
                />
              );
            })}
          {selectedProperty &&
            selectedProperty.boundaries &&
            selectedProperty.boundaries.length > 0 && ( // to get Selected Ptoprty Boundry on GoogleMap we need to add a Polgyon as child component
              <Polygon
                paths={selectedProperty.boundaries}
                options={{
                  fillColor: getFillColor(selectedProperty.landUseCategory),
                  fillOpacity: 0.4,
                  strokeColor: "blue",
                  strokeOpacity: 1,
                  strokeWeight: 2,
                }}
              />
            )}
          {/* {isShowProperties &&
            filteredPropertiesList &&
            filteredPropertiesList.length > 0 &&
            filteredPropertiesList.map((item, index) => {
              if (item.latitude && item.longitude) {
                return (
                  <Marker
                    key={index}
                    onClick={handleMapClick}
                    position={{
                      lat: Number(item.latitude),
                      lng: Number(item.longitude),
                    }}
                    title={item.name}
                    icon={
                      item.source == "STRIVE"
                        ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                        : item.source == "HSC"
                        ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                        : item.source == "External"
                        ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                        : item.source == "db"
                        ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                        : ""
                    }
                  />
                );
              }
            })} */}
          {userLocation && (
            <Marker
              position={userLocation}
              icon={{
                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
              }}
            />
          )}
          {/* New Investor details PopUp   */}
          {isInfoWindowOpen && (
            <InfoWindow
              position={{
                lat: selectedProperty.lat,
                lng: selectedProperty.lng,
              }}
              onCloseClick={() => setIsInfoWindowOpen(false)}
              options={{ headerDisabled: true }}
            >
              <div
                style={{
                  minWidth: "260px",
                  fontSize: "13px",
                  background: "white",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  overflow: "hidden",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background: "#90C54B",
                    color: "white",
                    fontWeight: "bold",
                    padding: "6px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                    }}
                  >
                    {propertyOwner ? (
                      <Link
                        to={{
                          pathname: `${basePath}/investor/${propertyOwner.contact_id || ""}`,
                          // state: {fromListUrl: "/contacts/investors" },
                        }}
                        onClick={() => {
                          localStorage.setItem("fromListUrl", "/contacts/investors");
                        }}
                        style={{ color: "white" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {`${propertyOwner.first_name || ""} ${propertyOwner.last_name || ""}`.trim() || "N/A"}
                      </Link>
                    ) : (
                      "N/A"
                    )}
                  </span>

                  <FaTimes
                    onClick={() => setIsInfoWindowOpen(false)}
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      marginLeft: "8px",
                    }}
                  />
                </div>

                {/* Body */}
                <div style={{ padding: "10px", background: "white" }}>
                  {propertyOwner ? (
                    <div>
                      {/* Phone Numbers */}
                      <p
                        style={{
                          margin: "4px 0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaPhone
                          style={{
                            marginRight: "6px",
                            fontSize: "14px",
                            color: "gray",
                          }}
                        />
                        (W): {propertyOwner.phone || "N/A"}
                      </p>
                      <p
                        style={{
                          margin: "4px 0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaPhone
                          style={{
                            marginRight: "6px",
                            fontSize: "14px",
                            color: "gray",
                          }}
                        />
                        (C):{propertyOwner.cell_phone || "N/A"}
                      </p>

                      {/* Email */}
                      <p
                        style={{
                          margin: "4px 0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaEnvelope
                          style={{
                            marginRight: "6px",
                            fontSize: "14px",
                            color: "gray",
                          }}
                        />
                        {propertyOwner.email ? (
                          <a
                            href={`mailto:${propertyOwner.email}`}
                            style={{
                              color: "#90C54B",
                              textDecoration: "none",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "85%",
                            }}
                          >
                            {propertyOwner.email}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </p>
                      {propertyOwner && propertyOwner.company_name ? (
                        <div
                          style={{
                            marginTop: "12px",
                            borderTop: "1px solid #eee",
                          }}
                        >
                          {/* Accordion Header */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                              padding: "8px 0",
                            }}
                            onClick={() =>
                              setShowCompanyDetails(!showCompanyDetails)
                            }
                          >
                            {clerks_Url ? (
                              <h4
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                <a
                                  href={clerks_Url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#90C54B",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  Company Details
                                </a>
                              </h4>
                            ) : (
                              <h4
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  color: "#444",
                                }}
                              >
                                Company Details
                              </h4>
                            )}

                            <span
                              style={{ fontSize: "12px", color: "#90C54B" }}
                            >
                              {showCompanyDetails ? "▲" : "▼"}
                            </span>
                          </div>

                          {/* Accordion Content */}
                          {showCompanyDetails && (
                            <div style={{ paddingBottom: "8px" }}>
                              {/* Company Name */}
                              <p
                                style={{
                                  margin: "4px 0",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "13px",
                                }}
                              >
                                <FaBuilding
                                  style={{
                                    marginRight: "6px",
                                    fontSize: "14px",
                                    color: "gray",
                                  }}
                                />
                                {propertyOwner.company_name || "N/A"}
                              </p>

                              {/* Company Address (icon + multiline wrapping) */}
                              <p
                                style={{
                                  margin: "4px 0",
                                  display: "flex",
                                  alignItems: "flex-start", // aligns icon top with text
                                  fontSize: "13px",
                                  flexWrap: "wrap", // allow wrapping
                                }}
                              >
                                <FaMapMarkerAlt
                                  style={{
                                    marginRight: "6px",
                                    fontSize: "14px",
                                    color: "gray",
                                    marginTop: "2px",
                                  }}
                                />
                                <span
                                  style={{
                                    wordWrap: "break-word", // wrap long words
                                    whiteSpace: "normal",  // allow text to break
                                    flex: 1,
                                  }}
                                >
                                  {propertyOwner.company_address || ""}
                                  {propertyOwner.company_city
                                    ? `, ${propertyOwner.company_city}`
                                    : ""}
                                  {propertyOwner.company_state
                                    ? `, ${propertyOwner.company_state}`
                                    : ""}
                                  {propertyOwner.company_zip
                                    ? ` ${propertyOwner.company_zip}`
                                    : ""}
                                  {!propertyOwner.company_address &&
                                    !propertyOwner.company_city &&
                                    !propertyOwner.company_state &&
                                    !propertyOwner.company_zip
                                    ? "N/A"
                                    : ""}
                                </span>
                              </p>

                              {/* Website */}
                              <p
                                style={{
                                  margin: "4px 0",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "13px",
                                }}
                              >
                                <FaGlobe
                                  style={{
                                    marginRight: "6px",
                                    fontSize: "14px",
                                    color: "gray",
                                  }}
                                />
                                {propertyOwner.website ? (
                                  <a
                                    href={
                                      propertyOwner.website.indexOf("http") === 0
                                        ? propertyOwner.website
                                        : "https://" + propertyOwner.website
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#90C54B", textDecoration: "none" }}
                                  >
                                    {propertyOwner.website}
                                  </a>
                                ) : (
                                  "N/A"
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      ) : null}
                      {/* Notes Section */}
                      {/* <div
                        style={{
                          marginTop: "8px",
                          padding: "6px 8px",
                          background: "#f9f9f9",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          maxHeight: "60px",
                          maxWidth: "220px",
                          overflowY: "auto", // vertical scroll
                          overflowX: "hidden", // no horizontal scroll
                          fontSize: "12px",
                          whiteSpace: "normal", // text wraps normally
                          wordBreak: "break-word",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Notes:</span>{" "}
                        <span style={{ display: "inline" }}>
                          {propertyOwner.notes || "N/A"}
                        </span>
                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center", // vertically centers
                          gap: "8px",
                        }}
                      >
                        <span className="view-link">
                          <a
                            style={{
                              marginTop: "3px",
                              color: "#7EB233",
                              fontSize: "small",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center", // makes text align better
                            }}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setNotesId("");
                              if (isInvestorEdit) {
                                isInvestorEdit.current = true;
                              }
                              setIsShowAddNotes(!showAddNotes);
                              setIsNotesReadOnly(false);
                            }}
                          >
                            Add Notes
                          </a>
                        </span>

                        <StriveNotesDrawer
                          propertyNotes={contactNotes}
                          setNotesId={setNotesId}
                          setTextInput={setTextInput}
                          setIsShowAddNotes={setIsShowAddNotes}
                          setIsNotesReadOnly={setIsNotesReadOnly}
                          loggedinuser={getUser()}
                          handleDeleteNote={handleDeleteNote}
                          showPorpertyNotes={false}
                          setContactNotes={setContactNotes}
                          isInvestorEdit={isInvestorEdit}
                        />
                      </div>



                      {/* Edit Notes Link */}
                      {/* <div style={{ marginTop: "6px", textAlign: "right" }}>
              <a
                href="#"
                onClick={() => {
                  setNotesId("owner_notes");
                  setTextInput(propertyOwner.notes || "");
                  setIsShowAddNotes(true);
                  setIsNotesReadOnly(false);
                }}
                style={{
                  fontSize: "12px",
                  color: "#90C54B",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Edit Notes
              </a>
            </div> */}
                    </div>
                  ) : (
                    <div style={{ lineHeight: "1.2", fontSize: "14px" }}>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <FaBuilding
                          style={{
                            marginRight: "6px",
                            fontSize: "12px",
                            color: "gray",
                          }}
                        />
                        {selectedProperty.owner || "N/A"}
                      </span>

                      <span style={{ display: "block" }}>
                        {selectedProperty.ownerStreetAddress || "N/A"}
                      </span>

                      <span style={{ display: "block" }}>
                        {`${selectedProperty.ownerLocality || ""} ${selectedProperty.ownerRegionCode || ""
                          } ${selectedProperty.ownerPostalCode || ""}`.trim() ||
                          "N/A"}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </InfoWindow>
          )}
          {/* old Investor details PopUp */}
          {/* {isInfoWindowOpen && (//Owner Pup-Up code when we click property boundary on map */}
          {/* //             <InfoWindow */}
          {/* //               position={{ */}
          {/* //                 lat: selectedProperty.lat, */}
          {/* //                 lng: selectedProperty.lng, */}
          {/* //               }} */}
          {/* //               onCloseClick={() => setIsInfoWindowOpen(false)} */}
          {/* //               options/={{ headerDisabled: true }} */}
          {/* //             > */}
          {/* //               <div className="info-window-container"> */}
          {/* //                 <FaTimes */}
          {/* //                   className="clear-info" */}
          {/* //                   onClick={() => setIsInfoWindowOpen(false)} */}
          {/* //                   height={16} */}
          {/* //                   width={16} */}
          {/* //                 /> */}
          {/* //               {propertyOwner ? ( */}
          {/* //   <div */}
          {/* //     style={{ */}
          {/* //       display: "flex", */}
          {/* //       flexDirection: "column", */}
          {/* //       gap: "4px", */}
          {/* //     }} */}
          {/* //   > */}
          {/* //     Link to Investor */}
          {/* //     <Link */}
          {/* //       to={{ */}
          {/* //         pathname: `${basePath}/investor/${propertyOwner.contact_id || ""}`, */}
          {/* //         state: { fromListUrl: '/contacts/investors' }, */}
          {/* //       }} */}
          {/* //       style={{ color: "#90C54B", textDecoration: "none", cursor: "pointer" }} */}
          {/* //       tabIndex={0} */}
          {/* //     > */}
          {/* //       <span> */}
          {/* //         {`${propertyOwner.first_name || ""} ${propertyOwner.last_name || ""}`.trim() || "N/A"} */}
          {/* //       </span> */}
          {/* //     </Link> */}
          // // {/* Phone Number */}
          {/* //     <span/> */}
          {/* //       (W): {propertyOwner.phone || "N/A"} */}
          {/* //     </span> */}
          // // {/* Cell Phone Number */}
          {/* //     <span> */}
          {/* //       (C): {propertyOwner.cell_phone || "N/A"} */}
          {/* //     </span> */}
          // // {/* Email */}
          {/* //     <span> */}
          {/* //       (E): {propertyOwner.email || "N/A"} */}
          {/* //     </span> */}
          // // {/* Notes */}
          {/* //     <div style={{ maxHeight: "120px", overflowY: "auto" }}> */}
          {/* //       <span>Notes - {propertyOwner.notes || "N/A"}</span> */}
          {/* //     </div> */}
          // // {/* Edit Notes Link */}
          {/* //     <div className="view-link"> */}
          {/* //       <a */}
          {/* //         href="#" */}
          {/* //         tabIndex={0} */}
          {/* //         onClick={() => { */}
          {/* //           setNotesId("owner_notes"); */}
          {/* //           setTextInput(propertyOwner.notes || ""); */}
          {/* //           setIsShowAddNotes(true); */}
          {/* //           setIsNotesReadOnly(false); */}
          {/* //         }} */}
          {/* //       > */}
          {/* //         <span>Edit Notes</span> */}
          {/* //       </a> */}
          {/* //     </div> */}
          {/* //   </div> */}
          {/* // ) : ( */}
          {/* //   <div */}
          {/* //     style={{ */}
          {/* //       display: "flex", */}
          {/* //       flexDirection: "column", */}
          {/* //       gap: "4px", */}
          {/* //     }} */}
          {/* //   > */}
          {/* //     <div style={{ lineHeight: '1.2', fontSize: '14px' }}> */}
          {/* //       <span style={{ display: 'block' }}>{selectedProperty.owner || "N/A"}</span> */}
          {/* //       <span style={{ display: 'block' }}>{selectedProperty.ownerStreetAddress || "N/A"}</span> */}
          {/* //       <span style={{ display: 'block' }}> */}
          {/* //         {`${selectedProperty.ownerLocality || ""} ${selectedProperty.ownerRegionCode || ""} ${selectedProperty.ownerPostalCode || ""}`.trim() || "N/A"} */}
          {/* //       </span> */}
          {/* //     </div> */}
          {/* //   </div> */}
          {/* // )} */}
          {/* //                 {/* <a */}
          {/* //                   target="_blank" */}
          {/* //                   style={{ color: "#90C54B", marginTop: "4px" }} */}
          {/* //                   jstcache="6" */}
          {/* //                   href={`https://www.google.com/maps?q=${selectedProperty.lat},${selectedProperty.lng}`} */}
          {/* //                   tabindex="0" */}
          {/* //                 > */}
          {/* //                   // {selectedProperty.address} */}
          {/* //                   {"Google Maps"} */}
          {/* //                 </a>  */}
          {/* //               </div> */}
          {/* //             </InfoWindow> */}
          {/* //           )} */}
          {!isStreetViewVisible && (
            <React.Fragment>
              <StriveVisionSearch
                searchType={searchType}
                fipsNumber={fipsNumber}
                setFipsNumber={setFipsNumber}
                handleValueChange={handleValueChange}
                handleClearInput={handleClearInput}
                apnNumber={apnNumber}
                setApnNumber={setApnNumber}
                handleSearch={handleSearch}
                address={address}
                setAddress={setAddress}
                fipsError={fipsError}
                apnError={apnError}
                searchError={searchError}
                addressError={addressError}
                selectedProperty={propertyForSearch}
                showPropertyPanel={showPropertyPanel}
                suggestions={suggestions}
                handleSuggestionClick={handleSuggestionClick}
                isSuggestionSelected={isSuggestionSelected}
                propertyNotes={propertyNotes}
                showAddNotes={showAddNotes}
                setIsShowAddNotes={setIsShowAddNotes}
                setNotesId={setNotesId}
                setTextInput={setTextInput}
                handleDeleteNote={handleDeleteNote}
                loggedinuser={getUser()}
                setIsNotesReadOnly={setIsNotesReadOnly}
                county_Url={county_Url}
              />
              {/* {showAddNotes && (
                // <Modal open={showAddNotes} onClose={closeModal}>
                //    <div
                //     style={{
                //       position: "absolute",
                //       top: "50%",
                //       left: "50%",
                //       transform: "translate(-50%, -50%)",
                //       width: 400,
                //       border: "2px solid #000",
                //       boxShadow: 24,
                //       padding: "12px",
                //       backgroundColor: "white",
                //       display: "flex",
                //       flexDirection: "column",
                //       gap: "12px",
                //     }}
                //   >
                //     {!isNotesReadOnly && (
                //       <span className="span-text">
                //         {notesId ? "Edit Note" : "Add Note"}
                //       </span>
                //     )}

                //     <textarea
                //       disabled={isNotesReadOnly}
                //       value={textInput}
                //       onChange={(e) => setTextInput(e.target.value)}
                //       placeholder="Type something for the test"
                //       rows="4"
                //       style={{
                //         minHeight: "260px",
                //         resize: "none",
                //       }}
                //     />

                //     <div
                //       style={{
                //         display: "flex",
                //         gap: "10px",
                //         justifyContent: "flex-end",
                //       }}
                //     >
                //       {!isNotesReadOnly ? (
                //         <React.Fragment>
                //           <button
                //             onClick={closeModal}
                //             style={{ cursor: "pointer" }}
                //           >
                //             Cancel
                //           </button>
                //           <button
                //             onClick={handleSubmit}
                //             style={{ cursor: "pointer" }}
                //           >
                //             {notesId ? "Save" : "Add"}
                //           </button>
                //         </React.Fragment>
                //       ) : (
                //         <button
                //           onClick={closeModal}
                //           style={{ cursor: "pointer" }}
                //         >
                //           Close
                //         </button>
                //       )}
                //     </div>
                //   </div>
                // </Modal>
              )} */}
              {showAddNotes && (
                <Dialog
                  open={showAddNotes}
                  onClose={closeModal}
                  PaperComponent={PaperComponent}
                  aria-labelledby="draggable-dialog-title"
                  disableEnforceFocus
                  disableAutoFocus
                >
                  <div
                    style={{
                      width: 400,
                      padding: "12px",
                      backgroundColor: "white",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {/* Always render draggable handle */}
                    <div
                      id="draggable-dialog-title"
                      style={{
                        cursor: "move",
                        fontWeight: "bold",
                        marginBottom: "8px",
                        minHeight: "20px",
                      }}
                    >
                      {!isNotesReadOnly
                        ? notesId
                          ? "Edit Note"
                          : "Add Note"
                        : ""}
                    </div>

                    <textarea
                      disabled={isNotesReadOnly}
                      value={textInput}
                      onChange={(e) => setTextInput(e.target.value)}
                      placeholder="Type something for the test"
                      rows="4"
                      style={{
                        minHeight: "260px",
                        resize: "none",
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "flex-end",
                      }}
                    >
                      {!isNotesReadOnly ? (
                        <div>
                          <button
                            onClick={closeModal}
                            style={{ cursor: "pointer", backgroundColor: "#90C54B", color: "ffff" }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSubmit}
                            style={{ cursor: "pointer", backgroundColor: "#90C54B", color: "ffff" }}
                          >
                            {notesId ? "Save" : "Add"}
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={closeModal}
                          style={{ cursor: "pointer", backgroundColor: "#90C54B", color: "ffff" }}
                        >
                          Close
                        </button>
                      )}
                    </div>
                  </div>
                </Dialog>
              )}
            </React.Fragment>
          )}
        </GoogleMap>
        <button
          title="Show Your Location"
          onClick={showLocation}
          className="show-location-button"
        >
          <FaLocationArrow />
        </button>
      </LoadScript>
    </div>
  );
}

export default StriveVision;
